import { render, staticRenderFns } from "./PopUpWashServices.vue?vue&type=template&id=b2dfd3cc&scoped=true&"
import script from "./PopUpWashServices.vue?vue&type=script&lang=js&"
export * from "./PopUpWashServices.vue?vue&type=script&lang=js&"
import style0 from "./PopUpWashServices.vue?vue&type=style&index=0&id=b2dfd3cc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2dfd3cc",
  null
  
)

export default component.exports